import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forth-page',
  templateUrl: './forth-page.component.html',
  styleUrls: ['./forth-page.component.css']
})
export class ForthPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
